import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface DashboardReducerState {
    currentSection: number;
    currentSubSection: number;
}

const initialState: DashboardReducerState = {
    currentSection: 0,
    currentSubSection: 0
}

export const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
        changeSection: (state, action: PayloadAction<number>) => {
            state.currentSection = action.payload;
        },
        changeSubSection: (state, action: PayloadAction<number>) => {
            state.currentSubSection = action.payload;
        }
    }
});

export const {
    changeSection,
    changeSubSection
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
